import styled from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";

export const Wrapper = styled.div`
  position: relative;
  padding: ${calculateResponsiveSize(120)} 0 0;
  ${mediaMax("tabletLandscape")} {
    padding-bottom: 24px;
  }
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: ${calculateResponsiveSize(120)};

  ${({ $padding }) => {
    switch ($padding) {
      case "full":
        return `
          padding-left: 11vw;
          padding-right: 11vw;
        `;
      // case "left":
      //   return `
      //     padding-left: 11vw;
      //   `;
      // case "right":
      //   return `
      //     padding-right: 11vw;
      //   `;
      default:
        return `
          padding: 0;
        `;
    }
  }}

  ${mediaMax("tabletLandscape")} {
    margin-bottom: 0;
    flex-direction: ${({ $mobileDirection }) =>
      $mobileDirection === "column-reverse" ? `column-reverse` : "column"};
    padding: ${({ $padding }) => ($padding === "full" ? "0 20px" : "0")};
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
  padding: ${({ $type }) => ($type === "copy" ? "0 11vw" : "")};
  ${mediaMax("tabletLandscape")} {
    width: 100%;
    ${({ $mobilePadding }) => {
      switch ($mobilePadding) {
        case "copyLeft":
          return `
          padding: 24px 20px 48px 66px;
        `;
        case "copyRight":
          return `
          padding: 24px 66px 48px 20px;
        `;
        case "imageLeft":
          return `
          padding-left: 66px;
        `;
        case "imageRight":
          return `
          padding-right: 66px;
        `;
        default:
          return `padding: 24px 20px 48px 20px`;
      }
    }}
  }
`;
